<script setup>
/**
 * Root page layout container that coordinates header, drawer, footer, and page areas.
 *
 * @status recommended
 * @group layout
 * @useWhen Creating a full-page layout with a header, optional drawer, and page content
 * @see https://quasar.dev/layout/layout Quasar q-layout API
 */
defineOptions({ name: 'HrLayout' });
</script>

<template>
  <q-layout v-bind="$attrs">
    <!-- @slot Page structure — HrHeader, HrDrawer, and HrPageContainer. -->
    <slot />
  </q-layout>
</template>
